import { create } from "zustand"
import { PrebookingRequest } from "./PrebookingRequest"
import axios from "axios"

interface Discount {
    discountName: string,
    discountValue: string
}

interface Price {
    fullPriceWithoutQueueBeforeDiscount: number,
    fullPriceWithQueueBeforeDiscount: number,
    fullPriceWithoutQueueAfterDiscount: number,
    fullPriceWithQueueAfterDiscount: number,
    discounts: Discount[]
}

interface SubeventSelectionResponse {
    subeventId: number,
    role: number,
    price: number,
    partnerPrice: number,
    inQueue: number
}

interface Partner {
    id: number,
    name: string,
    surName: string,
    price: Price,
    subevents: SubeventSelectionResponse[]
}

interface PrebookingResponse {
    eventId: number,
    price: Price,
    partners: Partner[],
    subevents: SubeventSelectionResponse[]
}

interface PrebookingResponseStore {
    prebookingResponse: PrebookingResponse | null,
    loading: boolean,
    getPrebookingResponse: (prebookingRequest: PrebookingRequest, onError: (err: any) => void, onSuccess: (data: any) => void) => void,
    resetPrebookingResponse: () => void
}

export const usePrebookingResponse = create<PrebookingResponseStore>((set, get) => ({
    prebookingResponse: null,
    getPrebookingResponse: async (prebookingRequest: PrebookingRequest, onError: (err: any) => void, onSuccess: (data: any) => void = () => { }) => {
        set({ loading: true })
        try {
            const res = await axios.post(`wp-json/tts-booking/v1/events/prebooking`, prebookingRequest);
            set({ prebookingResponse: res.data, loading: false });
            onSuccess(res.data);
        } catch (err) {
            onError(err);
            set({ loading: false, prebookingResponse: null });
            return;
        }

    },
    loading: false,
    resetPrebookingResponse: () => {
        set({ prebookingResponse: null });
    }
}));

export type { PrebookingResponse, SubeventSelectionResponse, Price, Discount };